<template>
  <div @submit.prevent>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status === ""'>
      <div v-if='time > 0' :data-time='time' class="rf-form">
        <template v-for='(field, index) in cpntField' v-if='field.hasOwnProperty("id") && field.tipo !== ""'>
          <RF-Input :key="index" v-if='field.tipo === "input"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntTabIndex='field.tabIndex'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntType='field.type'
            :cpntAutoComplete='field.autocomplete'
            :cpntMask='field.mask'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntAutoFocus='field.autofocus'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntPlaceholder='field.placeholder'
            :cpntExplica='field.explica'
            :cpntMaxLength='field.maxLength'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :cpntOnKeyPressEnter='field.onKeyPressEnter'
            :ref='field.tipo'
          ></RF-Input>

          <RF-Select-Color :key="index" v-else-if='field.tipo === "select-color"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntTabIndex='field.tabIndex'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntType='field.type'
            :cpntAutoComplete='field.autocomplete'
            :cpntMask='field.mask'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntAutoFocus='field.autofocus'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntPlaceholder='field.placeholder'
            :cpntExplica='field.explica'
            :cpntMaxLength='field.maxLength'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :cpntOnKeyPressEnter='field.onKeyPressEnter'
            :ref='field.tipo'
          ></RF-Select-Color>

          <RF-Input-Complite :key="index" v-else-if='field.tipo === "auto-complite"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntTabIndex='field.tabIndex'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntExplica='field.explica'
            :cpntPlaceholder='field.placeholder'
            :cpntValueRef='field.valueRef'
            :cpntRouter='field.router'
            :cpntMethod='field.method'
            :cpntField='field.field'
            :cpntFieldVirtuaxl='field.fieldVir'
            :cpntWhere='field.where'
            :cpntAddButForm='field.addButForm'
            :cpntKeyMostra='field.keyMostra'

            :cpntTipoOrder='field.tipoOrder'
            :cpntOrder='field.order'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :cpntOnRealizaBusca='field.onRealizaBusca'
            :cpntOnKeyPressEnter='field.onKeyPressEnter'
            :ref='field.tipo'
          ></RF-Input-Complite>

          <RF-Busca-ou-AutoComplite :key="index" v-else-if='field.tipo === "busca-ou-autocomplite"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            
            :cpntKeyValue='field.keyValue'
            :cpntKeyMostra='field.keyMostra'
            :cpntValueRef='field.valueRef'
            :cpntRouter='field.router'
            :cpntMethod='field.method'
            :cpntField='field.field'
            :cpntFieldVirtual='field.fieldVir'
            :cpntWhere='field.where'
            :cpntTipoOrder='field.tipoOrder'
            :cpntOrder='field.order'
            :cpntAddButForm='field.addButForm'

            :cpntOnRealizaBusca='field.onRealizaBusca'
            :cpntOnChange='field.onChange'
            :ref='field.tipo'
          ></RF-Busca-ou-AutoComplite>

          <RF-Input-Calendario :key="index" v-else-if='field.tipo === "input-calendario"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntAutoComplete='field.autocomplete'
            :cpntMask='field.mask'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntAutoFocus='field.autofocus'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntPlaceholder='field.placeholder'
            :cpntExplica='field.explica'
            :cpntConfig='field.config'
            :cpntPosicionar='field.posicionar'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :ref='field.tipo'
          ></RF-Input-Calendario>

          <RF-TextArea :key="index" v-else-if='field.tipo === "textarea"' 
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntAutoComplete='field.autocomplete'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntExplica='field.explica'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-TextArea>

          <RF-Ckeditor :key="index" v-else-if='field.tipo === "ckeditor"'
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntAutoComplete='field.autocomplete'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntConfig='field.config'
            :cpntExplica='field.explica'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Ckeditor>

          <RF-Select2 :key="index" v-else-if='field.tipo === "select2"' 
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntOptions='field.options'
            :cpntKeyValue='field.keyValue'
            :cpntKeyMostra='field.keyMostra'
            :cpntAutoComplete='field.autocomplete'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntOptionInicialNome='field.optionInicialNome'
            :cpntOptionInicialValue='field.optionInicialValue'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntAddOption='field.addOption'
            :cpntMultiple='field.multiple'
            :cpntExplica='field.explica'
            :cpntClassSelect='field.classSelect2'
            :cpntTabIndex='field.tabIndex'
            :cpntSearchMinimo='field.searchMinimo'

            :cpntOnKeyPressEnter='field.onKeyPressEnter'
            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Select2>

          <!-- <RF-Chosen v-else-if='field.tipo === "chosen"' 
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntOptions='field.options'
            :cpntKeyValue='field.keyValue'
            :cpntKeyMostra='field.keyMostra'
            :cpntAutoComplete='field.autocomplete'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntOptionInicialNome='field.optionInicialNome'
            :cpntOptionInicialValue='field.optionInicialValue'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntAddOption='field.addOption'
            :cpntMultiple='field.multiple'
            :cpntExplica='field.explica'
            :cpntClassSelect='field.classSelect2'
            :cpntTabIndex='field.tabIndex'

            :cpntOnKeyPressEnter='field.onKeyPressEnter'
            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Chosen> -->

          <RF-Select2-Chosen :key="index" v-else-if='field.tipo === "select2-chosen"' 
            :class='"class-time-" + time +  " rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntPosicaoNome='field.posicaoNome'
            :cpntValue='field.value'
            :cpntOptions='field.options'
            :cpntKeyValue='field.keyValue'
            :cpntKeyMostra='field.keyMostra'
            :cpntAutoComplete='field.autocomplete'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntSelecioneNome='field.selecioneNome'
            :cpntSelecioneValue='field.selecioneValue'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntAdicinarOption='field.adicinarOption'
            :cpntMultiple='field.multiple'
            :cpntAllRegistro='field.allRegistro'
            :cpntExplica='field.explica'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Select2-Chosen>

          <RF-Toggles--2 :key="index" v-else-if='field.tipo === "toggles--2"' 
            :data-time="time" :class='"rf-toggles rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntOptions='field.options'
            :cpntKeyValue='field.keyValue'
            :cpntKeyMostra='field.keyMostra'
            :cpntExplica='field.explica'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Toggles--2>

          <RF-Toggles :key="index" v-else-if='field.tipo === "toggles"' 
            :data-time="time" :class='"rf-toggles rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntClassDivField='field.classDivField'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntOn='field.on'
            :cpntOff='field.off'
            :cpntExplica='field.explica'
            :cpntWidth='field.width'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Toggles>

          <RF-Picker-Icon :key="index" v-else-if='field.tipo === "picker-icone"' 
            :data-time="time" :class='"RF-Picker-Icon rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntNome='field.nome'
            :cpntValue='field.value'
            :cpntDisabled='field.disabled'
            :cpntMostrar='field.mostrar'
            :cpntMensagem='field.mensagem'
            :cpntMensagemTipo='field.mensagemTipo'
            :cpntExplica='field.explica'
            :cpntTabIndex='field.tabIndex'

            :cpntOnChange='field.onChange'
            :cpntOnBlur='field.onBlur'
            :ref='field.tipo'
          ></RF-Picker-Icon>

          <RF-Status :key="index" v-else-if='field.tipo === "status"' 
            :data-time="time" 
            :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'
            v-show='field.mostrar'

            :cpntStatus='field.value'
            :cpntIcone='field.icone' 
            :cpntTamanho='field.iconeTamanho'
          ></RF-Status>

          <RF-Carousel :key="index" v-else-if='field.tipo === "carousel"' 
            :data-time="time" 
            :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntWidth='field.width'
            :cpntHeight='field.height'
            :cpntNome='field.nome'
            :cpntRefMod='field.refMod'
            :cpntRefId='field.refId'
            :cpntAnexarAoSelecionar='field.anexarAoSelecionar'

            :ref='field.tipo'
          ></RF-Carousel>

          <RF-Codigo-RF :key="index" v-else-if='field.tipo === "codigo-rf"' 
            :data-time="time" 
            :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index'

            :cpntStatus='field.status'
            :cpntId='field.id'
            :cpntRouter='field.router'
            :cpntMethod='field.method'
            :cpntMostrar='field.mostrar'
          ></RF-Codigo-RF>

          <div :key="index" v-else-if='field.tipo === "checkbox"' :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index' v-show="field.mostrar">
            <RF-Checkbox-Tabela
              :data-time="time"
              :cpntTime="time"

              :cpntStatus='""'
              :cpntId='field.id' 
              :cpntNome='field.nome'
              :cpntValue='field.value'
              :cpntChecked='field.selected'
              :cpntDisabled='field.disabled'
              :cpntExplica='field.explica'

              :cpntOnChange='field.onChange'
            ></RF-Checkbox-Tabela>
          </div>

          <div :key="index" v-else-if='field.tipo === "button"'
            :class="'rf-input-group rf-field-' + index + (field.hasOwnProperty('classDivField') ? ' ' + field.classDivField : '') + (field.hasOwnProperty('tamanho') ? ' rf-field-tamanho-' + field.tamanho : '')"
            v-show='field.mostrar'>
            <RF-Button
              style="width: 100%;"
              :data-time="time"

              :cpntId='field.id'
              :cpntClassDivField='field.classDivField'
              :cpntStatus='field.status' 
              :cpntTexto='field.texto' 
              :cpntClass='field.class'
              :cpntMostrar='field.mostrar'
              :cpntDisabled='field.disabled'
              :cpntTabIndex='field.tabIndex'
              :cpntIcone='field.icone'
              :cpntTipo='field.tipoButton'
              :cpntExplica='field.explica'
              :cpntTitle='field.title'

              @onClickButton='field.onClick'
              :ref='field.tipo'
            ></RF-Button>
          </div>

          <div :key="index" v-else-if='field.tipo === "explica"' 
            v-show='field.mostrar' class="rf-input-group"  
            :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index + (field.hasOwnProperty("classDivField") ? " " + field.classDivField : "")'>
            <RF-Explica 
              :cpntId='field.id' 
              :cpntTitle='field.mensagem'
              :cpntPositionMy='field.posicaoMy'
              :cpntPositionAt='field.posicaoAt'
              :cpntClasses='field.class'
            ></RF-Explica>
          </div>

          <div :key="index" class="rf-input-group rf-field-texto" v-else-if='field.tipo === "texto"' 
          v-show='field.mostrar' 
          :data-time="time" :class='"rf-field-tamanho-" + (field.hasOwnProperty("tamanho") ? field.tamanho : 0) + " rf-field-" + index + (field.hasOwnProperty("classDivField") ? " " + field.classDivField : "")'>
            <label :for="field.id" style="color: #666;">
              <span :data-time='time' v-html='field.nome'></span>

              <RF-Explica v-if='field.hasOwnProperty("explica") && field.explica !== null && Object.keys(field.explica).length >= 1'
                :cpntId='field.id + "-explica"' 
                :cpntTitle='field.explica.mensagem'
                :cpntPositionMy='field.explica.posicaoMy'
                :cpntPositionAt='field.explica.posicaoAt'
                :cpntClasses='field.explica.class'

                style='vertical-align: 0px;'
              ></RF-Explica>
            </label>
            <br/>
            <span :id="field.id" v-html='field.value'></span>
          </div>

          <div :key="index" v-else-if='field.tipo === "clear"' class='rf-limpa-float' :class="'rf-' + index" v-show="!field.hasOwnProperty('mostrar') || field.mostrar !== false" style="display: block; clear: both; width: 100%; height: 1px;">&nbsp;</div>

          <div :key="index" v-else style="color: red;">Campo não configurado no formulario. <br/>{{ field }}</div>
        </template>
        <template v-else-if='field.tipo !== ""'>
          <div style="color: red;"><b>Campo sem id informado.</b> <br/>{{ index }} - {{ field }}</div>
        </template>

        <div class="rf-ult-alt" v-if='cpntUltAlt.hasOwnProperty("data") && cpntUltAlt.hasOwnProperty("usu_id") && cpntUltAlt.hasOwnProperty("usu_nome")' style="padding: 10px 0px 20px;">
          <span>
            Última atualização: 
          </span>
          <span>
            {{ cpntUltAlt.usu_nome }} 
          </span>
          <span>
            em 
          </span>
          <span>
            {{ cpntUltAlt.data }}
          </span>
        </div>
      </div>

      <template v-if='time >= 1 && Object.keys(cpntButtons).length >= 1 && Object.keys(cpntButtons).filter(key => (cpntButtons[key].hasOwnProperty("mostrar") && cpntButtons[key].mostrar === true) || !cpntButtons[key].hasOwnProperty("mostrar")).length >= 1' :data-time='time'>
        <div :data-time="time" :class='"rf-buttons-form rf-field-tamanho-1"'>
          <template v-for='(button, index) in cpntButtons'>
            <RF-Button :key="index"
              :data-time='time'

              :cpntStatus='button.status' 
              :cpntId='button.id' 
              :cpntTexto='button.texto' 
              :cpntClass='button.class'
              :cpntMostrar='button.mostrar'
              :cpntTabIndex='button.tabIndex'

              @onClickButton='onClickButton'
            ></RF-Button>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .rf-form > .rf-cpnt-group {
    margin-bottom: 30px;
  }
</style>

<script>
export default {
  name: 'RF-Formulario',
  components: {
    'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue'),
    'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
    'RF-Input-Complite': () => import('@/components/rf-geral/input-complite/RF-Input-Complite.vue'),
    'RF-Busca-ou-AutoComplite': () => import('@/components/rf-geral/busca-ou-autocomplite/busca-ou-autocomplite.vue'),
    'RF-Input-Calendario': () => import('@/components/rf-geral/input-calendario/RF-Input-Calendario.vue'),
    'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
    'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
    'RF-Codigo-RF': () => import('@/components/rf-geral/codigo-rf/RF-Codigo-RF.vue'),
    'RF-Toggles': () => import('@/components/rf-geral/toggles/RF-Toggles.vue'),
    'RF-Toggles--2': () => import('@/components/rf-geral/toggles/RF-Toggles--2.vue'),
    'RF-Select2-Chosen': () => import('@/components/rf-geral/select2-chosen/RF-Select2-Chosen.vue'),
    'RF-TextArea': () => import('@/components/rf-geral/textarea/RF-TextArea.vue'),
    'RF-Ckeditor': () => import('@/components/rf-geral/ckeditor/RF-Ckeditor.vue'),
    'RF-Select-Color': () => import('@/components/rf-geral/select-color/RF-Select-Color.vue'),
    'RF-Picker-Icon': () => import('@/components/rf-geral/picker-icon/picker-icon.vue'),
    'RF-Carousel': () => import('@/components/rf-geral/carousel/RF-Carousel.vue')
  },
  props: {
    // PEGA O STATUS DO FORMULARIO
    cpntStatus: {
      required: true
    },

    // PEGA O STATUS DO FORMULARIO
    cpntId: {
      required: true,
      type: String
    },

    // PEGA OS CAMPOS QUE DEVEM SER CRIADOS
    cpntField: {
      required: true,
      type: Object
    },

    // PEGA OS CAMPOS QUE DEVEM SER CRIADOS
    cpntTabIndexFieldGeral: {
      required: false,
      type: Number,
      default: function () {
        return 1
      }
    },

    // PEGA OS CAMPOS QUE DEVEM SER CRIADOS
    cpntTabIndexButtonGeral: {
      required: false,
      type: Number,
      default: function () {
        return 1
      }
    },

    // PEGA O STATUS DO FORMULARIO
    cpntTime: {
      required: true,
      type: [ String, Number ]
    },

    // PEGA OS DADOS PARA PREENCHER QUEM FOI A ULTIMA PESSOA QUE EDITOR ESSE REGISTRO
    cpntUltAlt: {
      required: false,
      type: Object,
      default: function () {
        return {}
      }
    },

    // PEGA OS BUTTONS DO FORMULARIO
    cpntButtons: {
      required: false,
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      time: '',
      status: 'carregando'
    }
  },
  mounted: function () {
    this.iniciarFormulario()
  },
  methods: {
    iniciarFormulario: function () {
      var self = this

      // SETA O STATUS DO FORMULARIO
      self.status = 'carregando'

      // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
      self.time = new Date().getTime()

      if (self.cpntStatus === '') {
        // CRIA OS IDS DOS CAMPOS
        for (var campo in self.cpntField) {
          self.cpntField[campo].id = self.cpntId + '-' + campo

          if (!self.cpntField[campo].hasOwnProperty('tabIndex') || (self.cpntField[campo].tabIndex <= 1 || self.cpntField[campo].tabIndex === '' || self.cpntField[campo].tabIndex === null)) {
            self.cpntField[campo].tabIndex = self.cpntTabIndexFieldGeral
          }
        }

        // CRIA OS IDS DOS CAMPOS
        for (var button in self.cpntButtons) {
          if (!self.cpntButtons[button].hasOwnProperty('id')) {
            self.cpntButtons[button].id = self.cpntId + '-' + button
          }

          if (!self.cpntButtons[button].hasOwnProperty('tabIndex') || (self.cpntButtons[button].tabIndex <= 1 || self.cpntButtons[button].tabIndex === '' || self.cpntButtons[button].tabIndex === null)) {
            self.cpntButtons[button].tabIndex = self.cpntTabIndexButtonGeral
          }
        }

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        setTimeout(function () {
          // SETA O STATUS DO FORMULARIO
          self.status = ''

          // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
          self.time = new Date().getTime()
        }, 500)
      }
    },
    onClickButton: function (idInicial) {
      var self = this

      // PEGA QUAL FOI O BOTÃO CLICADO
      var indexButton = Object.keys(self.cpntButtons).filter(item => self.cpntButtons[item].id === idInicial)[0]

      // VERIFICA SE TEM FUNÇÃO ONCLICK
      if (self.cpntButtons[indexButton].hasOwnProperty('onClick')) {
        self.cpntButtons[indexButton].onClick(self.cpntButtons[indexButton].id)
      } else {
        // EMITE O EVENTO PARA INCIAR AÇÃO NO COMPONENT PAI
        self.$emit('onClickButton', indexButton)
      }

      // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
      self.time = new Date().getTime()
    },
    onFocusCampo: function (campo, scroll = false, tentativa = 0) {
      if (campo) {
        var self = this

        setTimeout(function () {
          if (self.cpntStatus === '' && self.status === '') {
            if (self.cpntField.hasOwnProperty(campo) && Object.keys(self.$refs).length >= 1 && self.$refs[self.cpntField[campo].tipo] !== undefined) {
              var field = self.$refs[self.cpntField[campo].tipo].filter(item => item.cpntId === self.cpntField[campo].id)

              if (field.length === 1 && field[0].hasOwnProperty('onFocusField')) {
                field[0].onFocusField(scroll)
              } else if (tentativa <= 10) {
                self.onFocusCampo(campo, scroll, (tentativa + 1))
              }
            } else if (tentativa <= 10) {
              self.onFocusCampo(campo, scroll, (tentativa + 1))
            }
          } else if (tentativa <= 10) {
            self.onFocusCampo(campo, scroll, (tentativa + 1))
          }
        }, (tentativa === 0 ? 0 : 200))
      }
    },
    onFocusButton: function (button) {
      var self = this

      $('#' + self.cpntButtons[button].id).focus()
    }
  },
  watch: {
    'cpntStatus': function () {
      if (this.cpntStatus === '') {
        this.iniciarFormulario()
      }
    },
    'cpntField': function () {
      if (this.cpntStatus === '') {
        this.iniciarFormulario()
      }
    },

    // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
    'cpntTime': function () {
      this.time = new Date().getTime()
    }
  }
}
</script>

<style scoped>
  .rf-form {
    user-select: auto;
  }
    .rf-form > div {
      max-width: 100%;
      display: inline-block;
      vertical-align: top;
    }  
  .rf-ult-alt {
    display: block;
    margin-top: -15px;
    user-select: none;
  }
    .rf-ult-alt > span {
      color: var(--color-base-02);
    }

  .rf-buttons-form {
    text-align: center;
  }
    .rf-buttons-form > button {
      margin: 0px 5px 5px 5px;
    }
</style>
